export default "__VITE_ASSET__CNfnnSkT__"